<template>
  <div>
    <BaseHeader
      :title="$t('settings.title')"
      :style-variant="6"
      icon="mdi-cog"
    >
      <template
        v-if="!isPlatformBottimmo"
        #design
      >
        <HeaderDesign />
      </template>

      <template #desc>
        <p>{{ $t('settings.subtitle') }}</p>
      </template>
    </BaseHeader>
    <v-card
      border
      class="pa-4 mb-5"
    >
      <v-card-text>
        <v-tabs
          v-model="section"
          show-arrows
          height="40"
        >
          <v-tab
            v-for="{ name } in sections"
            :key="name"
            class="rounded-0"
          >
            {{ $t(name) }}
          </v-tab>
        </v-tabs>

        <v-divider />

        <v-window
          v-model="section"
          class="pt-4"
        >
          <v-window-item
            v-for="{ name } in sections"
            :key="name"
          >
            <component
              v-if="currentComponent"
              :is="currentComponent"
            />
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </div>
</template>
<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import BaseHeader from '@/components/BaseHeader.vue'
import { useBranding } from '@/composables/useBranding'
import useFeature from '@/composables/useFeature'
import featureNames from '@/lib/featureNames'
import MasterCrmSettings from '@/modules/master/settings/MasterCrmSettings.vue'
import HeaderDesign from '@/modules/settings/HeaderDesign.vue'
import { RoleProvider } from '@/providers/roleProvider'

const { isPlatformBottimmo } = useBranding()
const role = inject<RoleProvider>('role')
const { isFeatureActive } = useFeature()
const section = ref(0)
const sectionConfig = [
  {
    path: 'crm',
    name: 'settings.crm.name',
    permission: 'settings-crm:read',
    feature: featureNames.CRM,
    component: MasterCrmSettings,
    show: undefined,
  },
]

const sections = computed(() => {
  return sectionConfig
    .filter(({ show }) => show === undefined || show())
    .filter(({ permission }) => role.isAuthorizedFor(permission))
    .filter(({ feature }) => feature === undefined || isFeatureActive(feature))
})

const activePath = ref<string>(sectionConfig[0].path)

const activeSection = computed(() => sectionConfig.find((s) => s.path === activePath.value) ?? null)
const currentComponent = computed(() => activeSection.value?.component ?? null)
</script>
